module.exports = __webpack_public_path__ + "assets/img/20210927-3.b93a4822.png";